import React, {FunctionComponent, useMemo, useState} from 'react';
import {DateTime} from 'luxon';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/client';
import Card from '../card/Card';
import CardTitle from '../card/CardTitle';
import TitleCaption from '../card/TitleCaption';
import TitleNumber from '../card/TitleNumber';
import CardContent from '../card/CardContent';
import {ISchedule} from '../../../models/event/Schedule';
import {ILocation} from '../../../models/event/Location';
import CalendarTable from './CalendarTable';

interface Statistics {
  students: number;
  soldTickets: number;
}

export interface FutureEvent {
  id: number;
  title: string;
  confirmed: boolean;
  schedule: ISchedule;
  location: ILocation;
  statistics: Statistics;
}

interface EventsFeed {
  total: number;
  events: FutureEvent[];
}

interface EventsFeedData {
  feed: EventsFeed;
}

interface EventsFeedVars {
  count: number;
  endBeginsOn: DateTime;
}

const query = gql`
  query FutureEventsCardQuery($endBeginsOn: DateTime!, $count: Int!) {
    feed: events(endBeginsOn: $endBeginsOn, orderBy: start_asc, count: $count) {
      total
      count
      skip

      events {
        id
        title
        confirmed
        schedule {
          start
          end
          timezone
        }
        location {
          online
          country
          city
        }
        statistics {
          students
          soldTickets
        }
      }
    }
  }
`;

const CalendarCard: FunctionComponent = () => {
  const [total, setTotal] = useState(0);

  const endBeginsOn = useMemo(() => DateTime.utc().plus({minutes: 1}), []);
  const count = 5;

  const {data, loading} = useQuery<EventsFeedData, EventsFeedVars>(query, {
    variables: {
      count, endBeginsOn,
    },
    onCompleted: (feedData) => setTotal(feedData.feed.total > count ? count : feedData.feed.total),
  });

  return (
    <Card wide={true} loading={loading}>
      <CardTitle wide={false}>
        <TitleCaption subtitle="only next 5 events">Calendar</TitleCaption>
        <TitleNumber value={total}/>
      </CardTitle>
      {data && data.feed.total !== 0 &&
      <CardContent className="text-base" noBorders={false}>
        <CalendarTable events={data.feed.events}/>
      </CardContent>
      }
    </Card>
  );
};

export default CalendarCard;
